import script from "./PdAccordion.vue?vue&type=script&setup=true&lang=js"
export * from "./PdAccordion.vue?vue&type=script&setup=true&lang=js"

import "./PdAccordion.vue?vue&type=style&index=0&id=4df3a401&scoped=true&lang=css"

import exportComponent from "../../../paydeck-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4df3a401"]])

export default __exports__